import { Text } from '@chakra-ui/react';
import React from 'react';
import { Page } from '~components/ui/Page';
import { PageContent } from '~components/ui/PageContent';

export function ForbiddenPage() {
  return (
    <Page title="403" pageName="403_forbidden" analyticsDisableTracking={true}>
      <PageContent maxWidth="300px" textAlign="center">
        <Text fontWeight="semibold" color="gray.600">
          You don&apos;t have permissions to access any organization.
        </Text>

        <Text marginTop="8" fontSize="sm">
          Looks like something went wrong. Please contact support for help.
        </Text>
      </PageContent>
    </Page>
  );
}
